<template>
  <a
    :href="$vuetify.lang.t('$vuetify.kba.logo.href')"
    :title="$vuetify.lang.t('$vuetify.kba.logo.title')"
    target="_blank"
  >
    <v-img
      :width="width"
      :height="height"
      :src="require('../assets/logo.png')"
    />
  </a>
</template>

<script>
const ORIGINAL_WIDTH = 1200
const ORIGINAL_HEIGHT = 849

export default {
  name: 'KbaLogo',
  props: {
    width: {
      type: Number,
      required: false,
      default: 115
    }
  },
  computed: {
    height () {
      return (this.width * ORIGINAL_HEIGHT) / ORIGINAL_WIDTH
    }
  }
}
</script>
